import { render, staticRenderFns } from "./AuditoriaMolexDataBarHallazgos.vue?vue&type=template&id=60378b1c"
import script from "./AuditoriaMolexDataBarHallazgos.vue?vue&type=script&lang=js"
export * from "./AuditoriaMolexDataBarHallazgos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports